<div class="translate-modal">
  <h2>{{ 'translateModal.title' | translate }}</h2>
  <p class="subtitle">{{ 'translateModal.subtitle' | translate }}</p>

  <div class="file-box">
    <img class="file-icon" src="assets/pdf.svg" alt="PDF"/>
    <div class="file-info">
      <span class="file-name">{{ fileName }}</span>
      <ng-container *ngIf="uploadDate">
        <span class="file-date">
          {{ 'translateModal.uploaded' | translate }} : {{ uploadDate | date: 'MMMM d, y, hh:mm a' }}
        </span>
      </ng-container>
    </div>
  </div>

  <div class="form-field">
    <label>{{ 'translateModal.fields.source' | translate }}</label>

    <app-dropdown
      [items]="languages"
      bindLabel="name"
      bindValue="name"
      [multiple]="false"
      [clearable]="false"
      [formControl]="sourceLangCtrl"
      placeholder="Select language"
    >
      <ng-template #optionTpl let-language>
        <div class="option" style="display:flex;align-items:center;gap:.5rem;">
          <img
            [src]="'assets/icons/flags/4x3/' + (language.code || language) + '.svg'"
            [alt]="(language?.name ?? language) + ' flag'"
            style="width:1rem;height:auto;border-radius:2px;"
          />
          <span>{{ language?.name ?? language }}</span>
        </div>
      </ng-template>

      <ng-template #selectedItemTpl let-language>
        <div class="selected-item" style="display:flex;align-items:center;gap:.5rem;">
          <img
            [src]="'assets/icons/flags/4x3/' + (language.code || language) + '.svg'"
            [alt]="(language?.name ?? language) + ' flag'"
            style="width:1rem;height:auto;border-radius:2px;"
          />
          <span>{{ language?.name ?? language }}</span>
        </div>
      </ng-template>
    </app-dropdown>
  </div>


  <!-- Target language -->
  <div class="form-field">
    <label>{{ 'translateModal.fields.target' | translate }}</label>

    <app-dropdown
      [items]="languages"
      bindLabel="name"
      bindValue="name"
      [multiple]="false"
      [clearable]="false"
      [formControl]="targetLangCtrl"
      placeholder="Select language"
    >
      <ng-template #optionTpl let-language>
        <div class="option" style="display:flex;align-items:center;gap:.5rem;">
          <img
            [src]="'assets/icons/flags/4x3/' + (language.code || language) + '.svg'"
            [alt]="(language?.name ?? language) + ' flag'"
            style="width:1rem;height:auto;border-radius:2px;"
          />
          <span>{{ language?.name ?? language }}</span>
        </div>
      </ng-template>

      <ng-template #selectedItemTpl let-language>
        <div class="selected-item" style="display:flex;align-items:center;gap:.5rem;">
          <img
            [src]="'assets/icons/flags/4x3/' + (language.code || language) + '.svg'"
            [alt]="(language?.name ?? language) + ' flag'"
            style="width:1rem;height:auto;border-radius:2px;"
          />
          <span>{{ language?.name ?? language }}</span>
        </div>
      </ng-template>
    </app-dropdown>
  </div>


  <!-- Footer buttons -->
  <div class="modal-actions">
    <app-button [label]="'common.cancel' | translate"
                [type]="ButtonType.SECONDARY"
                [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR" (click)="onCancel()"></app-button>
    <app-button
      [label]="'translateModal.actions.translate' | translate"
      [type]="ButtonType.PRIMARY"
      [showLeftIcon]="true"
      [leftIcon]="'assets/translate-button.svg'"
      [size]="ButtonSize.LARGE"
      [state]="ButtonState.REGULAR" (click)="onTranslate()">
      <mat-icon>auto_fix_high</mat-icon>
      Translate document
    </app-button>
  </div>
</div>
